(function () {
  'use strict';

  const i18n = window.npI18n || {};

  // ─── Nährwert-Konfiguration (Label, Einheit, EU-NRV) ────────────────────────
  const SECTIONS = {
    nutrients: {
      heading: i18n.headingNutrients || 'Nährwerte pro 100 g',
      rows: {
        energy_kj:     { label: i18n.labelEnergy          || 'Energie',                     unit: 'kJ',   nrv: 8400, sub: false },
        energy_kcal:   { label: i18n.labelEnergy          || 'Energie',                     unit: 'kcal', nrv: 2000, sub: false, skip: true },
        fat:           { label: i18n.labelFat              || 'Fett',                        unit: 'g',    nrv: 70,   sub: false },
        fat_saturated: { label: i18n.labelFatSaturated     || 'davon gesättigte Fettsäuren', unit: 'g',    nrv: 20,   sub: true  },
        carbohydrates: { label: i18n.labelCarbohydrates    || 'Kohlenhydrate',               unit: 'g',    nrv: 260,  sub: false },
        sugar:         { label: i18n.labelSugar            || 'davon Zucker',                unit: 'g',    nrv: 90,   sub: true  },
        fiber:         { label: i18n.labelFiber            || 'Ballaststoffe',               unit: 'g',    nrv: null, sub: false },
        protein:       { label: i18n.labelProtein          || 'Eiweiß',                      unit: 'g',    nrv: 50,   sub: false },
        salt:          { label: i18n.labelSalt             || 'Salz',                        unit: 'g',    nrv: null, sub: false },
      }
    },
    vitamins: {
      heading: i18n.headingVitamins || 'Vitamine',
      rows: {
        vitamin_a:        { label: i18n.labelVitaminA        || 'Vitamin A',       unit: 'μg',  nrv: 800,  sub: false },
        vitamin_d:        { label: i18n.labelVitaminD        || 'Vitamin D',       unit: 'μg',  nrv: 5,    sub: false },
        vitamin_e:        { label: i18n.labelVitaminE        || 'Vitamin E',       unit: 'mg',  nrv: 12,   sub: false },
        vitamin_k:        { label: i18n.labelVitaminK        || 'Vitamin K',       unit: 'μg',  nrv: 75,   sub: false },
        vitamin_c:        { label: i18n.labelVitaminC        || 'Vitamin C',       unit: 'mg',  nrv: 80,   sub: false },
        thiamine:         { label: i18n.labelThiamine        || 'Thiamin (B1)',     unit: 'mg',  nrv: 1.1,  sub: false },
        riboflavin:       { label: i18n.labelRiboflavin      || 'Riboflavin (B2)', unit: 'mg',  nrv: 1.4,  sub: false },
        niacin:           { label: i18n.labelNiacin          || 'Niacin',          unit: 'mg',  nrv: 16,   sub: false },
        vitamin_b6:       { label: i18n.labelVitaminB6       || 'Vitamin B6',      unit: 'mg',  nrv: 1.4,  sub: false },
        folic_acid:       { label: i18n.labelFolicAcid       || 'Folsäure',        unit: 'μg',  nrv: 200,  sub: false },
        vitamin_b12:      { label: i18n.labelVitaminB12      || 'Vitamin B12',     unit: 'μg',  nrv: 2.5,  sub: false },
        biotin:           { label: i18n.labelBiotin          || 'Biotin',          unit: 'μg',  nrv: 50,   sub: false },
        pantothenic_acid: { label: i18n.labelPantothenicAcid || 'Pantothensäure',  unit: 'mg',  nrv: 6,    sub: false },
      }
    },
    minerals: {
      heading: i18n.headingMinerals || 'Mineralstoffe',
      rows: {
        potassium:  { label: i18n.labelPotassium  || 'Kalium',    unit: 'mg',  nrv: 2000, sub: false },
        chloride:   { label: i18n.labelChloride   || 'Chlor',     unit: 'mg',  nrv: 800,  sub: false },
        calcium:    { label: i18n.labelCalcium    || 'Calcium',   unit: 'mg',  nrv: 800,  sub: false },
        phosphorus: { label: i18n.labelPhosphorus || 'Phosphor',  unit: 'mg',  nrv: 700,  sub: false },
        magnesium:  { label: i18n.labelMagnesium  || 'Magnesium', unit: 'mg',  nrv: 375,  sub: false },
        iron:       { label: i18n.labelIron       || 'Eisen',     unit: 'mg',  nrv: 14,   sub: false },
        zinc:       { label: i18n.labelZinc       || 'Zink',      unit: 'mg',  nrv: 10,   sub: false },
        copper:     { label: i18n.labelCopper     || 'Kupfer',    unit: 'mg',  nrv: 1,    sub: false },
        manganese:  { label: i18n.labelManganese  || 'Mangan',    unit: 'mg',  nrv: 2,    sub: false },
        selenium:   { label: i18n.labelSelenium   || 'Selen',     unit: 'μg',  nrv: 55,   sub: false },
        chromium:   { label: i18n.labelChromium   || 'Chrom',     unit: 'μg',  nrv: 40,   sub: false },
        molybdenum: { label: i18n.labelMolybdenum || 'Molybdän',  unit: 'μg',  nrv: 50,   sub: false },
        iodine:     { label: i18n.labelIodine     || 'Jod',       unit: 'μg',  nrv: 150,  sub: false },
      }
    }
  };

  // ─── DOM-Referenzen ─────────────────────────────────────────────────────────
  const overlay  = document.getElementById('nutrition-popup');
  if (!overlay) return;

  const modal      = overlay.querySelector('.np-modal');
  const titleEl    = overlay.querySelector('.np-modal__title');
  const closeBtn   = overlay.querySelector('.js-np-close');
  const ingSection = overlay.querySelector('.js-np-ingredients');
  const ingText    = overlay.querySelector('.js-np-ingredients-text');
  const tableWrap  = overlay.querySelector('.js-np-table');

  // ─── State ──────────────────────────────────────────────────────────────────
  const cache = {};
  let lastTrigger = null;

  // ─── Daten laden ────────────────────────────────────────────────────────────
  function loadData(productId) {
    if (cache[productId]) return;
    const el = document.querySelector(`.js-np-data[data-product-id="${productId}"]`);
    if (!el) { cache[productId] = {}; return; }
    try {
      cache[productId] = JSON.parse(el.textContent);
    } catch (e) {
      cache[productId] = {};
    }
  }

  function getVariantData(productId, variantId) {
    loadData(productId);
    return (cache[productId] || {})[variantId] || { nutrition: null, ingredients: null };
  }

  // ─── Öffnen / Schließen ─────────────────────────────────────────────────────
  function openPopup(trigger) {
    lastTrigger = trigger;
    const { productId, variantId, productTitle, variantTitle } = trigger.dataset;
    const data = getVariantData(productId, variantId);

    render(productTitle, variantTitle, data.nutrition, data.ingredients);

    overlay.classList.add('is-open');
    overlay.removeAttribute('aria-hidden');
    document.body.style.overflow = 'hidden';
    closeBtn.focus();
  }

  function closePopup() {
    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (lastTrigger) lastTrigger.focus();
  }

  // ─── Rendern ────────────────────────────────────────────────────────────────
  function escapeHtml(str) {
    return (str || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function render(productTitle, variantTitle, nutrition, ingredients) {
    const showVariant = variantTitle && variantTitle !== 'Default Title';
    titleEl.innerHTML = showVariant
      ? `${escapeHtml(productTitle)}<span class="np-modal__subtitle">${escapeHtml(variantTitle)}</span>`
      : escapeHtml(productTitle);

    // Zutaten (rich text → innerHTML)
    if (ingredients) {
      ingText.innerHTML = ingredients;
      ingSection.style.display = '';
    } else {
      ingSection.style.display = 'none';
    }

    // Nährwerttabelle
    tableWrap.innerHTML = '';
    if (!nutrition) return;

    let hasNrv = false;
    const servingG      = nutrition.serving_size_g || 125;
    const colPer100g    = i18n.colPer100g || 'je 100 g';
    const colNrv        = i18n.colNrv     || 'NRV*';
    const colPerServing = 'je ' + servingG + ' g';   // non-breaking space

    // Nährstoffe: 2 Spalten / Vitamine + Mineralstoffe: 5 Spalten
    Object.entries(SECTIONS).forEach(([sectionKey, sectionCfg]) => {
      const sectionData = nutrition[sectionKey];
      if (!sectionData) return;

      const isNutrients = sectionKey === 'nutrients';

      const hasData = Object.keys(sectionCfg.rows).some(
        key => !sectionCfg.rows[key].skip && sectionData[key] != null
      );
      if (!hasData) return;

      const wrap = document.createElement('div');
      wrap.className = 'np-table-section';

      const heading = document.createElement('p');
      heading.className = 'np-table-heading';
      heading.textContent = sectionCfg.heading;
      wrap.appendChild(heading);

      const table = document.createElement('table');
      table.className = 'np-table';

      // Kopfzeile
      const thead = table.createTHead();
      const hRow = thead.insertRow();
      const headers = isNutrients
        ? ['', colPer100g]
        : ['', colPer100g, colNrv, colPerServing, colNrv];
      headers.forEach(text => {
        const th = document.createElement('th');
        th.innerHTML = text;
        hRow.appendChild(th);
      });

      const tbody = table.createTBody();

      Object.entries(sectionCfg.rows).forEach(([key, cfg]) => {
        if (cfg.skip) return;
        const value = sectionData[key];
        if (value == null) return;

        const row = tbody.insertRow();
        if (cfg.sub) row.classList.add('is-sub');

        if (key === 'energy_kj') {
          // Energie: kJ und kcal kombiniert
          const kcal        = sectionData['energy_kcal'] != null ? sectionData['energy_kcal'] : null;
          const kjServing   = Math.round(value * servingG / 100);
          const kcalServing = kcal != null ? Math.round(kcal * servingG / 100) : null;

          row.insertCell().textContent = cfg.label;
          row.insertCell().textContent = kcal != null ? value + ' kJ / ' + kcal + ' kcal' : value + ' kJ';
          if (!isNutrients) {
            row.insertCell().textContent = cfg.nrv ? Math.round(value / cfg.nrv * 100) + ' %' : '—';
            row.insertCell().textContent = kcalServing != null ? kjServing + ' kJ / ' + kcalServing + ' kcal' : kjServing + ' kJ';
            row.insertCell().textContent = cfg.nrv ? Math.round(kjServing / cfg.nrv * 100) + ' %' : '—';
          }
        } else {
          const perServing = Math.round(value * servingG / 100 * 10) / 10;

          row.insertCell().textContent = cfg.label;
          row.insertCell().textContent = value + ' ' + cfg.unit;
          if (!isNutrients) {
            row.insertCell().textContent = cfg.nrv ? Math.round(value / cfg.nrv * 100) + ' %' : '—';
            row.insertCell().textContent = perServing + ' ' + cfg.unit;
            row.insertCell().textContent = cfg.nrv ? Math.round(perServing / cfg.nrv * 100) + ' %' : '—';
          }
        }

        if (!isNutrients && cfg.nrv) hasNrv = true;
      });

      table.appendChild(tbody);
      wrap.appendChild(table);
      tableWrap.appendChild(wrap);
    });

    if (hasNrv) {
      const footnote = document.createElement('p');
      footnote.className = 'np-footnote';
      footnote.textContent = i18n.footnote || '* Referenzwert für die durchschnittliche erwachsene Person (8400 kJ/2000 kcal)';
      tableWrap.appendChild(footnote);
    }
  }

  // ─── Event Listener ─────────────────────────────────────────────────────────
  document.addEventListener('click', function (e) {
    if (e.target.closest('.js-np-trigger')) {
      openPopup(e.target.closest('.js-np-trigger'));
      return;
    }
    if (e.target.closest('.js-np-close')) {
      closePopup();
      return;
    }
    if (e.target === overlay) {
      closePopup();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && overlay.classList.contains('is-open')) {
      closePopup();
    }
  });

  // ─── Fokus-Falle (Accessibility) ────────────────────────────────────────────
  overlay.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab') return;
    const focusable = [...modal.querySelectorAll(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
    )].filter(el => !el.disabled);
    if (!focusable.length) return;
    const first = focusable[0];
    const last  = focusable[focusable.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault(); last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault(); first.focus();
    }
  });

  // ─── Victory Variant-Change Event ───────────────────────────────────────────
  function bindVariantEvents() {
    // Das Change-Event kommt von der Produkt-Form-Section, nicht von der Ingredients-Section.
    // Deshalb auf alle Sections der Seite subscriben und Trigger per Produkt-ID matchen.
    document.querySelectorAll('[id^="shopify-section-"]').forEach(function (sectionEl) {
      const sectionId = sectionEl.id.replace('shopify-section-', '');
      window.themeCore.EventBus.listen(
        'pdp:section-' + sectionId + ':change-variant',
        function (payload) {
          if (!payload || !payload.variant) return;
          document.querySelectorAll('.js-np-trigger').forEach(function (trigger) {
            if (payload.product && String(payload.product.id) !== trigger.dataset.productId) return;
            trigger.dataset.variantId    = String(payload.variant.id);
            trigger.dataset.variantTitle = payload.variant.title || '';
          });
        }
      );
    });
  }

  if (window.themeCore && window.themeCore.EventBus) {
    bindVariantEvents();
  } else {
    document.addEventListener('theme:all:loaded', bindVariantEvents, { once: true });
  }

})();
